
import { IYoelloTheme } from "../../../../yoello-lib/modules/themes/IYoelloTheme";
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { CSSProperties } from "@material-ui/core/styles/withStyles";


function setItemFontStyles(fontFamily: string,
  fontStyle: string,
  fontWeight: any,
  fontSize: string,
  lineHeight: string,
  color: string): CSSProperties {
  return {
    fontFamily: fontFamily,
    fontStyle: fontStyle,
    fontWeight: fontWeight,
    fontSize: fontSize,
    lineHeight: lineHeight,
    color: color,
  }
}
export const useStyles = makeStyles((theme: IYoelloTheme) =>
  createStyles({
    addExtrasContainer: {
      "& label": {
        ...setItemFontStyles("sofia-pro, 'Open Sans', Helvetica, Arial, sans-serif",
          "normal", 400, "1rem", "1rem", "#757575"),
        paddingLeft: "6px"
      },
      "& >div": {
        border: "1px solid #E8EAF4",
        padding: "0.9375rem 0",
        marginTop: "10px",
        borderRadius: "10px"
      },
      "& >div>div": {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        "& p": {
          ...setItemFontStyles("Open Sans", "normal", "normal", "0.875rem", "1.1875rem", "#737FA4"),
        }
      },
      "& >div>div:first-child": {
        padding: "0 1.5625rem"
      },
      "& >div>div:last-child>div": {
        padding: "0 1.5625rem"
      }
    },
    selectedItemsText: {
      fontFamily: "Open Sans !important",
      fontStyle: "normal !important",
      fontWeight: "600 !important" as unknown as number,
      fontSize: "0.9375rem !important",
      lineHeight: "22px !important",
      color: "#212121 !important",
    },
    actionbarContainer: {
      display: "flex",
      flexDirection: "column",
      padding: "1.25rem 3rem",
      "& div:first-child": {
        display: "flex",
        "& div:first-child": {
          "& p:first-child": {
            ...setItemFontStyles("Open Sans", "normal", 600, "15px", "22px", "#212121")
          },
          "& p:last-child": {

          }
        }
      },
      "& div:last-child": {

      }
    },
    ModalContainer: {
      "& .MuiDialog-paperWidthMd": {
        width: "52.25rem!important",
        minWidth:"30rem!important"
      },
    },
    SelectedMenuItemsComponentDiv: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      height: "100%",
      margin: "0 1.5625rem",
      borderRadius: "8px",
      padding: "0.9375rem 1.875rem",
      "&:hover": {
        background: "#F3F4F9!important"
      },
      "& >div:first-child": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        "& >p:first-child": {
          fontSize: "1rem",
          color: "#212121",
          margin: "0",
          whiteSpace: "nowrap",
          overflow:" hidden !important",
          textOverflow: "ellipsis",
          width:"350px",
          "@media only screen and (max-width: 767px)": {
            width:"220px!important",
          },
        },
        "& p:last-child": {
          fontSize: "0.875rem",
          color: "#757575",
          margin: "0",
          paddingTop: "0.3125rem",
          whiteSpace: "nowrap",
          overflow:" hidden !important",
          textOverflow: "ellipsis",
          width:"350px",
          "@media only screen and (max-width: 767px)": {
            width:"220px!important",
          },
        }
      },
      "& button": {
        padding: "0.625rem",
        width: "fit-content",
        minWidth: "unset",
        "& svg": {
          "& path": {
            fill: "#C1CAE1!important"
          }
        }
      }
    },
    priceOptionItem:{
      margin:"0.3125rem 0",
     "& >div":{
        display: "flex",
        justifyContent:" space-around",
        "& >span":{
          ...setItemFontStyles("Open Sans","normal","normal","0.875rem","1.1875rem","#616161"),
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          width:"25%"
      }
    }
    },
    columnsHeader:{
      display: "flex",
      justifyContent:" space-between",
      alignItems: "center",
      width:"100%",
      "& >div":{
          width: "25%",
        "& >span":{
          ...setItemFontStyles("Open Sans","normal","normal","0.9rem","1.25rem","#8D98B7"),
          display: "flex",
          justifyContent:"flex-start",
          alignItems: "center",
        }
      }
    },
    priceOptionsContainer:{
      width:"25rem",
      "@media only screen and (max-width: 767px)": {
        width:"17.5rem!important",
      },
    },
    itemContentWrapper:{
      height: "100%",
      "& >div": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        "& >p:first-child": {
          fontSize: "1rem",
          color: "#212121",
          margin: "0",
          whiteSpace: "nowrap",
          overflow:" hidden !important",
          textOverflow: "ellipsis",
          width:"350px",
          "@media only screen and (max-width: 767px)": {
            width:"220px!important",
          },
        },
        "& p:last-child": {
          fontSize: "0.875rem",
          color: "#757575",
          margin: "0",
          paddingTop: "0.3125rem",
          whiteSpace: "nowrap",
          overflow:" hidden !important",
          textOverflow: "ellipsis",
          width:"350px",
          "@media only screen and (max-width: 767px)": {
            width:"220px!important",
          },
        }
      },
    },
    TooltipTexPartOne:{
      margin:0,
      "& span:first-child":{
        width: "1.25rem",
        display: "inline-block",
        margin: "0 6px",
        position: "relative",
        top: "-13px",
      },
      "& svg":{
        position:"absolute",
        width: "1.25rem",
        height: "1.25rem",
      }
    },
    reOrderingListContainer: {
      maxHeight:"300px",
      overflow:"auto",
      "&.draggable": {
        padding: "1rem 0.75rem",
        display:"flex",
        flexDirection:"column",
        height:"auto",
        overflow:"auto",
        margin:"0 0.75rem"
      },

      "& .draggable-card": {
        display: "flex",
        position: "relative",
        flexDirection: "row",
        marginBottom: "15px",
        cursor: "move",
        width:"100%",
        padding:"0!important",
        boxShadow: "1px 1px 3px rgb(0 0 0 / 20%)",
        borderRadius: "0.625rem",
        "&:hover": {
          backgroundColor:"#F3F4F9",
          top: "-2px",
          left: "-2px",
          boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
        },
      },

      "& .draggable-handler": {
        width: "4.375rem",
        backgroundImage: 'url("/assets/images/icon-handler.svg")',
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        flexShrink: "0",
        display: "block",
        "@media only screen and (max-width: 600px)": {
          display: "none",
        },
      },

      "& .draggable-onDrag": {
        width: "4.375rem",
        backgroundImage: 'url("/assets/images/icon-dnd-touch.svg")',
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        flexShrink: 0,
      },
      "& .draggable-item": {
        width: "100%",
        cursor: "pointer",
        display: "flex",
        padding: "1.25rem",
        paddingLeft: 0,
        overflow: "hidden",
        alignItems: "center",
        justifyContent: "space-between",
        "& >div:last-child":{
          display:"flex",
          justifyContent:"center",
          alignItems:"center",
          "& >button":{
            position:"inherit!important",
            padding:"0!important",
            width:"36px!important",
            minWidth:"36px!important",
            height:"36px!important",
            "& svg >path":{
              fill:"#8D98B7"
            }
          },
        },
        "& >div>div>p:first-child":{
          ...setItemFontStyles("Open Sans","normal","normal","1rem","1.375rem","#212121"),
          margin:0
        },
        "& >div>div>p:last-child":{
          ...setItemFontStyles("Open Sans","normal","normal","0.875rem","1.1875rem","#757575"),
          margin:0,
          marginTop:"0.3125rem"
        },
        "@media only screen and (max-width: 1280px)": {
          display: "flex !important",
        }
      },
    },

  }),
);